import { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import WorkspaceLoading from "../components/WorkspaceLoading";
import RequireSession from "../components/RequireSession";
import { bootstrapAdmin } from "../features/admin/adminSlice";
import { fetchCurrentUserThunk } from "../features/session/sessionSlice";
import AdminLayout from "../layout/AdminLayout";
import {
  BrandsPage,
  CatalogImportBatchPage,
  CatalogImportPage,
  CategoriesPage,
  CustomersPage,
  OperationsPage,
  OrdersPage,
  ProductEditorPage,
  ProductsPage,
  ProfilePage,
  SettingsPage,
  WorkflowManagementPage,
} from "./lazyPages";
import DashboardPage from "../pages/DashboardPage";
import LoginPage from "../pages/LoginPage";

function LazyRouteBoundary() {
  return (
    <Suspense fallback={<WorkspaceLoading />}>
      <Outlet />
    </Suspense>
  );
}

function App() {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.admin.status);
  const isAuthenticated = useSelector((state) => state.session.isAuthenticated);
  const profileStatus = useSelector((state) => state.session.profileStatus);

  useEffect(() => {
    if (isAuthenticated && status === "idle") {
      dispatch(bootstrapAdmin());
    }
  }, [dispatch, isAuthenticated, status]);

  useEffect(() => {
    if (isAuthenticated && profileStatus === "idle") {
      dispatch(fetchCurrentUserThunk());
    }
  }, [dispatch, isAuthenticated, profileStatus]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireSession />}>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route element={<LazyRouteBoundary />}>
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/new" element={<ProductEditorPage />} />
            <Route path="/products/:productId" element={<ProductEditorPage />} />
            <Route path="/catalog-import" element={<CatalogImportPage />} />
            <Route path="/catalog-import/batches/:batchId" element={<CatalogImportBatchPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/operations" element={<OperationsPage />} />
            <Route path="/workflow-management" element={<WorkflowManagementPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}

export default App;
